import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import request from './utils/request'
import store from './store'

Vue.use(ElementUI)
Vue.config.productionTip = false

// 将request实例挂载到Vue原型上，便于组件中使用
Vue.prototype.$http = request

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')